import { InputLabel, Stack, Typography } from '@mui/material';

export default function KeyValueDisplay({ title, data }) {
  return (
    <Stack>
      <InputLabel shrink>{title}</InputLabel>
      <Typography variant="body1" gutterBottom>
        {data}
      </Typography>
    </Stack>
  );
}
